<script setup>
import DisclosureSection from "../DisclosureSection.vue";
import { useI18n } from "vue-i18n";
import { FormSwitch } from "@Components/Form";

const props = defineProps(["modelValue"]);
const emit = defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();
</script>

<template>
    <DisclosureSection :title="__('Paramètres SEO')" default-open>
        <div class="p-3 space-y-6">
            <div class="space-y-3">
                <FormSwitch v-model="modelValue.modules.wordpress.seo_title.enabled">
                    <span class="text-white">{{ __("Générer la balise title SEO") }}</span>
                </FormSwitch>
                <div v-if="modelValue.modules.wordpress.seo_title.enabled" class="ml-14">
                    <FormSwitch v-model="modelValue.modules.wordpress.seo_title.emojis.enabled">
                        <span class="text-white">{{ __("Autoriser les emojis dans la balise title") }}</span>
                    </FormSwitch>
                </div>
                <FormSwitch v-model="modelValue.modules.wordpress.seo_description.enabled">
                    <span class="text-white">{{ __("Générer la Meta description SEO") }}</span>
                </FormSwitch>
            </div>
        </div>
    </DisclosureSection>
</template>
